import { Component, Input } from '@angular/core';
import { Week } from '../../model/Week';

import { NavController } from 'ionic-angular/navigation/nav-controller';
import { TimeReportingPage } from '../../pages/time-reporting/time-reporting';
import { CoreProvider } from '../../providers/core-service/core-service';

/**
 * Generated class for the CommonHeaderComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */


@Component({
  selector: 'manager-card',
  templateUrl: 'manager-card.html'
})
export class ManagerCardComponent {

  @Input() week: Week;
  @Input() showConfirmed: boolean;

  constructor(
    private nav: NavController,
    private coreService: CoreProvider
  ) {
  }

  openDetail(user: any) {
    this.nav.push(TimeReportingPage, { userdata: user });
  }

  /**
   * Visualizza colore stato in base al valore passato
   * @param value 
   * @param place 
   */
  stateView(value:string, place?:string):string{
    
    let statusLabel = {
      "Headquarter": "assets/imgs/Status-Headquarter.png",
      "Bank Holiday": "assets/imgs/Status-Holiday.png",
      "Travel": "assets/imgs/Status-Travel.png",
    };

    if (place) {
      if (value.indexOf(place) > -1)
        return statusLabel.Travel;
      else
        return statusLabel["Bank Holiday"];
    } else {
      for (let i in statusLabel) {
        if (value == i) {
          return statusLabel[i];
        } else if (this.coreService.getLeaveLabel().indexOf(value) > -1){
          return "assets/imgs/Status-Leave.png";
        }
      }
    }

    return statusLabel.Travel;
  
  }

}



// WEBPACK FOOTER //
// ./src/components/manager-card/manager-card.ts